import { useStaticQuery, graphql } from 'gatsby'

export default () => {
  const data = useStaticQuery(graphql`
    query ContactInfo {
      allContentfulContact {
        edges {
          node {
            id,
            label,
            value
            ranking,
            enabled,
          }
        }
      }
    }
  `)

  return data.allContentfulContact.edges
    .filter(currContact => currContact.node.enabled)
    .reduce((contactSheet, currContact) => {
      const contact = {
        id: currContact.node.id,
        label: currContact.node.label,
        value: currContact.node.value,
        ranking: currContact.node.ranking,
      }

      return [...contactSheet, contact]
    }, [])
    .sort((a, b) => {
      if (a.ranking < b.ranking) return -1
      if (a.ranking > b.ranking) return 1

      return 0
    })
}
